<script lang="ts">
    import { getJobs } from "../api"
    import Jobs from "./Jobs.svelte"

    let jobs: Job[] = []
    let limitView = 9

    let loadingJobs = false
    async function loadJobs() {
        loadingJobs = true

        const _jobs = await getJobs()
        jobs = _jobs
        loadingJobs = false
    }

    if (typeof window !== "undefined") {
        window.addEventListener(
            "scroll",
            () => {
                const { scrollTop, scrollHeight, clientHeight } = document.documentElement

                if (scrollTop + clientHeight >= scrollHeight - 5 && jobs.length > limitView) {
                    limitView += 9
                }
            },
            {
                passive: true,
            }
        )
    }

    getJobs().then((r: Job[]) => {
        jobs = r
    })
</script>

{#if loadingJobs}
    lade...
{:else}
    <div class="jobs-list">
        {#each jobs.slice(0, limitView) as item}
            <Jobs item="{item}" />
        {/each}
    </div>
{/if}
